import { Localizacao } from './../models/localizacao';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { HttpHeaders, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalizacaoService {
private readonly PATH = '/Localizacao';
private readonly PATH_ALT = '/Localizacao';
private readonly PATH_GET_ALL = '/Localizacao/GetAll';

  constructor(private http:HttpClient) { }

  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }),
  };
  public errorHandl(error: HttpErrorResponse) {
    return throwError(error.message || 'Server Error');
  }

  insert(localizacao:Localizacao):Observable<any>{
    return this.http.post(env.baseurl + this.PATH,localizacao,{responseType:'text'});
  }

  localizacaoAll():Observable<any> {
    return this.http.get(env.baseurl + this.PATH);

  }

  localizacaoById(cD_BPM_LOCALIZACAO_PATRIMONIAL:number):Observable<any>{
    return this.http.get(env.baseurl + this.PATH +'/'+ cD_BPM_LOCALIZACAO_PATRIMONIAL)
  }

  listarPage(dS_BPM_UF_UNIDADE:string,page:any): Observable<any> {
    return this.http.post(env.baseurl + 
      this.PATH_GET_ALL + '/'+ dS_BPM_UF_UNIDADE,page) 
    .pipe(catchError(this.errorHandl));
  }

  update(cD_BPM_LOCALIZACAO_PATRIMONIAL:number,localizacao:Localizacao):Observable<any>{
    return this.http.put(
      env.baseurl + this.PATH_ALT
      + '/' + cD_BPM_LOCALIZACAO_PATRIMONIAL,localizacao,{responseType:'text'}).
      pipe(catchError(this.errorHandl));
  }

  delete(cD_BPM_LOCALIZACAO_PATRIMONIAL:number):Observable<any>{
    return this.http.delete(env.baseurl + this.PATH +'/'+ cD_BPM_LOCALIZACAO_PATRIMONIAL,{responseType:'text'})
  }
}
